import {WhitelabelEventWithPayload} from "../../events/Events";
import {EventBus} from "../../events/EventBus";
import makeUserSearchUrlForStaticFilters, {TrovitUserSearchUrlParams} from "../../../../trovit/ts/core/url/urlGenerator";
import UserSearch from "../../../../mitula/ts/components/userSearch/userSearch";
import {
    ModalBlock,
    WindowService
} from "../../../../trovit/ts/core/url/services/GetNumberOfListingsAjax";
import {types} from "sass";
import {FILTER_NAMES} from "../../serp/filters/constants";
import {userSearchFormData} from "../../../../mitula/ts/serp/filters/filterFormData";




// export class WindowService {
//     updateURLWithoutPageReload(url: string) {
//         window.history.pushState(null, '', url);
//     }
// }

export interface GetNumberOfListingRequestEventPayload {
    buttonId: string;
}

export class GetNumberOfListingRequestEvent implements WhitelabelEventWithPayload<GetNumberOfListingRequestEventPayload> {
    type: string;
    payload: GetNumberOfListingRequestEventPayload;
    static readonly TYPE: string = 'get-number-of-listing-request';

    constructor(payload: GetNumberOfListingRequestEventPayload) {
        this.type = GetNumberOfListingRequestEvent.TYPE;
        this.payload = payload;
    }
}

export interface ListingsFilteringResponseEventPayload {
    numberOfFilteredResults: string;
    buttonId: string;
}

export class ListingsFilteringResponseEvent implements WhitelabelEventWithPayload<ListingsFilteringResponseEventPayload> {
    type: string;
    payload: ListingsFilteringResponseEventPayload;
    static readonly TYPE: string = 'listing-filtering-response';

    constructor(payload: ListingsFilteringResponseEventPayload) {
        this.type = ListingsFilteringResponseEvent.TYPE;
        this.payload = payload;
    }
}

// export interface ModalBlock {
//     blockFullscreenModal(): void;
//
//     unblockFullscreenModal(): void;
// }
//
// export class FullScreenModalBlock implements ModalBlock {
//     private readonly modalName;
//
//     constructor(modalName: string) {
//         this.modalName = modalName;
//     }
//
//     blockFullscreenModal = () => {
//         const modal = document.getElementById(this.modalName);
//         if (modal) {
//             modal.style.display = 'flex';
//         }
//     };
//
//     unblockFullscreenModal = () => {
//         const modal = document.getElementById(this.modalName);
//         if (modal) {
//             modal.style.display = 'none';
//         }
//     };
// }

export interface FiltersParams {
    // originHost: string;
    // typeId: string;
    // isSem: boolean;
    // currentOrigin: number;
    buttonId: string,
    geoId: string,
    roomsMin: string,
    roomsMax: string,
    bathRoomsMin: string,
    bathRoomsMax: string,
    priceMin: string,
    priceMax: string,
    areaMin: string,
    areaMax: string,
    propertyTypes: string,
    amenities: string,
    operationType: string,
    type: string,
    sorting: string,
    freeText: string,
    daysSincePublication: string,
    bankProperty: string,
    furnished: string,
    stratum: string,
    nearbyPoiTypeDistance: string,
}

export class GetNumberOfListingsAjax {
    // private readonly windowService: WindowService;
    private readonly eventBus: EventBus
    // private readonly modalBlock: ModalBlock;

    constructor(
        // windowService: WindowService,
        eventBus: EventBus,
        // modalBlock: ModalBlock
    ) {
        // this.windowService = windowService;
        this.eventBus = eventBus;
        // this.modalBlock = modalBlock;
    }

    execute(params: FiltersParams): void {
        //
        // this.modalBlock.blockFullscreenModal();

        // this.windowService.updateURLWithoutPageReload(
        //     makeUserSearchUrlForStaticFilters(params)
        // );

        fetch('/wl/api/v1/filter', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        }).then(async (response) => {
                if (response.ok) {
                    let payload = JSON.parse(await response.text()) as ListingsFilteringResponseEventPayload;
                    payload.buttonId = params.buttonId;
                    this.eventBus.emit(
                        new ListingsFilteringResponseEvent(
                            payload
                        )
                    )
                }
                // this.modalBlock.unblockFullscreenModal();
            }
        );
    }

}